import {
    Card,
    CardActions,
    CardContent,
    Box,
    Button,
    Grid,
    Typography,
} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import React from 'react';
import {toSnakeCase} from 'components/forms/locale/utils';
import {PList} from 'components/TypographyShortcuts';
import fields from 'components/forms/uscgaops/fields.js';
import {Link} from 'react-router-dom';
import {sumToFixed} from 'utils/arrays';

const useStyles = makeStyles(theme => ({
    root: {
        backgroundColor: theme.palette.gray.light,
    },
    details: {
        display: 'block',
    },
    noUnderline: {
        textDecoration: 'none',
    },
    fullWidth: {
        width: '100%',
    },
    whiteBackground: {
        background: 'white',
    },
}));

const printValue = value => {
    if (Array.isArray(value)) {
        return value.reduce((sum, entry) => sum + entry, 0).toFixed(2);
    } else if (value === true || value === 'true') {
        return 'Yes';
    } else if (value === false || value === 'false') {
        return 'No';
    } else {
        return `${value}`;
    }
};

const ListFields = ({data, fieldsToShow}) => {
    return fieldsToShow.map(field => {
        if (
            data[field] !== null &&
            data[field] !== undefined &&
            data[field] !== ''
        ) {
            return (
                <PList key={`${toSnakeCase(data.vessel_name)}-${field}`}>
                    {fields[field]?.review_label || fields[field]?.label}:{' '}
                    {printValue(data[field])}
                </PList>
            );
        } else {
            return null;
        }
    });
};

const AopsCard = ({state, index, allowEdit = true}) => {
    const classes = useStyles();

    return (
        <Card className={classes.root}>
            <CardContent>
                <Typography variant='body1'>
                    <strong>Underway Hours Report</strong>
                </Typography>
                <Box mb={2}>
                    <ListFields
                        data={state}
                        fieldsToShow={[
                            'aops_uscg_uw_hours_total',
                            'date_reported',
                            'date_detached',
                            'rank_E',
                            'rank_CWO',
                            'rank_O',
                            'rating',
                        ]}
                    />
                </Box>
                <Box mb={1}>
                    <Card>
                        <CardContent>
                            <Grid container justifyContent='space-between'>
                                <Grid item>
                                    <strong>Coxswain</strong>
                                </Grid>
                                <Grid item>
                                    Total U/W Hours:{' '}
                                    {sumToFixed(
                                        state?.aops_uscg_uw_hours_coxswain,
                                        2
                                    )}
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                </Box>
                <Card>
                    <CardContent>
                        <Grid container justifyContent='space-between'>
                            <Grid item>
                                <strong>Engineer</strong>
                            </Grid>
                            <Grid item>
                                Total U/W Hours:{' '}
                                {sumToFixed(
                                    state?.aops_uscg_uw_hours_engineer,
                                    2
                                )}
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </CardContent>
            {allowEdit ? (
                <CardActions>
                    <Link
                        to='/forms/uscgaops/rank-rating'
                        className={`${classes.noUnderline} ${classes.fullWidth}`}
                    >
                        <Button fullWidth color='primary' variant='contained'>
                            Edit Entry
                        </Button>
                    </Link>
                </CardActions>
            ) : null}
        </Card>
    );
};

export default AopsCard;
